import AddressPredictionsViewCmp from '@porterin/booking-flow/src/order-review/view/components/AddressPredictionsViewCmp';
import WaypointIcon from '@porterin/booking-flow/src/order-review/view/components/WaypointIcon';
import { OrderReviewLabels } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import { AddressType } from '@porterin/booking-flow/src/order-review/view/types/OrderReviewAddressSchema';
import { TextInput } from '@porterin/component-library/src/base-components';
import IconTitleCmp from '@porterin/component-library/src/composite-components/icon-title/IconTitleCmp';
import { AutoDetectLocationCmp } from '@porterin/component-library/src/location-accuracy/components/AutoDetectLocationCmp';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { backArrowIcon } from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

const Config: AppConfig = getAppConfig();

export interface SelectLocationProps {
  close_modal: () => void;
  predictions: google.maps.places.AutocompletePrediction[];
  on_prediction_click: (
    prediction: google.maps.places.AutocompletePrediction,
  ) => void;
  error: string | undefined;
  register: UseFormRegisterReturn<AddressType>;
}

export const SelectLocationViewCmp: React.FC<SelectLocationProps> = ({
  close_modal,
  predictions,
  on_prediction_click,
  error,
  register,
}) => {
  const { state } = useLocation();

  return (
    <div className="w-screen h-screen bg-[#f9f9f9] overflow-hidden">
      <div className="flex flex-col bg-white p-[2rem] rounded-b-lg shadow-md">
        <IconTitleCmp
          icon={backArrowIcon}
          onIconClick={() => close_modal()}
          text={`${OrderReviewLabels.waypointPrefix} ${state.waypoint}?`}
        />
        <form className="w-full mt-[2rem]">
          <TextInput
            data-testid="custom-address-edit"
            identifiers={{ id: 'custom-address-edit' }}
            inputOptions={{
              placeholder: OrderReviewLabels.addressInputPlaceholder,
              error: error,
            }}
            autoFocus={true}
            icons={{ leftIcon: <WaypointIcon waypoint={state.waypoint} /> }}
            {...register}
          />
        </form>
        <AutoDetectLocationCmp />
      </div>
      <AddressPredictionsViewCmp
        predictions={predictions}
        on_prediction_click={on_prediction_click}
      />
    </div>
  );
};
